<script>
import abmComp from '@/components/tools/abm';
import Abm from '@/base/abm';
export default {
    name: 'abm-error-signature',
    props: ['endpoint', 'options', 'tableName', 'refresh',],
    mixins: [abmComp],
    mounted () {
        this.customFilters.push(
            {name: 'Ignored', editor: 'checkbox', label: 'Ignorados', callback: () => {
                this.getAbm();
            }},
            {name: 'Resolved', editor: 'checkbox', label: 'Resueltos', callback: () => {
                this.getAbm();
            }},
        )
        this.filtersValues.Ignored = false;
        this.filtersValues.Resolved = false;
    },
    methods: {
        async getAbm () {
            let endpoint = this.applyFilters();
            this.abm = await new Abm({options: this.options, endpoint, table: this.tableName});
            if (!this.options.serverSide) {
                await this.fetchList(true);
            }
        },
        applyFilters () {
            let endpoint = this.endpoint;
            if (this.filtersValues.Ignored) {
                 endpoint = `${this.endpoint}&Ignored=1`;
            }
            if (this.filtersValues.Resolved) {
                 endpoint = `${endpoint}&Resolved=1`;
            }
            return endpoint
        },
    }
}
</script>